module.exports = __webpack_public_path__ + "img/img4_5.d81a8863.jpeg";